import { createContext } from 'react';

export default createContext<'en' | 'no'>('no');
